export const OVERRIDE_LOGOS = ['HJ', 'SL', 'TI', 'XN', 'MP', '4U', 'AV', 'KE', '9L', 'GI'];